import testinomial1 from  'assets/images/testinomail1.png';
import testinomial2 from  'assets/images/testinomail2.png';
import testinomial3 from  'assets/images/testinomial3.png';
// import testinomial4 from 'assets/images/testinomail4.png';
import testinomial4 from 'assets/images/testinomail4.png';

const testinomail=[
{
"id":1,
"user_name":"Sachin Singh",
"review":"Task Exhibitor is a lifesaver for students like me! With a hectic schedule, this task and project management system efficiently organizes my academic and personal tasks.",
"bg_color":"rgba(199, 172, 172, 0.50)",
"img_path":testinomial1
},
{
"id":2,
"user_name":"Akshay Gautam",
"review":"Task Exhibitor has transformed my student life! As a busy college student juggling classes, work, and extracurriculars, staying organized was a challenge until I found this game-changer.",
"bg_color":"rgb(84 90 185 / 22%)",
"img_path":testinomial2
},
{
"id":3,
"user_name":"Deepak Mishra",
"review":"Task Exhibitor is a must-have tool for every student! As a high schooler preparing for college applications, I had a lot on my plate. Thanks to Task Exhibitor, managing become easy.",
"bg_color":"rgba(45, 198, 219, 0.12)",
"img_path":testinomial3
},
{
"id":4,
"user_name":"Aman Pandey",
"review":"Task Exhibitor is a true student lifesaver! Being a busy high school student preparing for college, it effortlessly manages my academic tasks, volunteer work, and college research.",
"bg_color":"rgba(126, 28, 254, 0.1)",
"img_path":testinomial4
}
]

export default testinomail;